import React from 'react';

import Card from '../../atoms/Card';
import Grid from '../../atoms/Grid';
import { BswReceptionContent, BswReceptionContentsDetail } from '../../../external/CustomerInfoAllApi';
import ReceptionContentsTable from '../ReceptionContentsTable';
import sortBy from 'lodash/sortBy';

const formatFormNumberAndTypeName = (data: BswReceptionContentsDetail[]): string => {
  if (data.length === 0) {
    return '';
  }

  // 第1ソート: receptionNumber、第2ソート: acceptedDateTime、第3ソート: bswApplicationInfoId (登録連携情報画面とソート基準を合わせる)
  return sortBy(data, [(reception) => reception.bswApplicationFormNumber || '', (reception) => reception.businessTypeName || ''])
    .map((v) => {
      const bswApplicationFormNumber = v.bswApplicationFormNumber || '未発番';
      return v.businessTypeName ? `${bswApplicationFormNumber} （${v.businessTypeName}）` : bswApplicationFormNumber;
    })
    .join('\n');
};

export interface BswReceptionContentsTableProps {
  data: BswReceptionContent[];
}

const BswReceptionContentsTable: React.FC<BswReceptionContentsTableProps> = ({ data }) => {
  // bswReceptionNumberは使わない(使えない)のでbswApplicationFormNumber昇順並び替え先頭を使う
  const convertedData = data.map((bswData) => {
    if (bswData.receptionContentsDetail.length) {
      bswData.receptionContentsDetail = sortBy(bswData.receptionContentsDetail, 'bswApplicationFormNumber');
      bswData.bswReceptionNumber = bswData.receptionContentsDetail[0].bswApplicationFormNumber;
    } else {
      bswData.bswReceptionNumber = '';
    }
    return bswData;
  });

  return (
    <>
      {sortBy(convertedData, [(bsw) => bsw.bswReceptionNumber || '', (bsw) => bsw.acceptedDateTime || '', 'bswApplicationInfoId']).map(
        (item, index) => {
          return (
            <Card className='u-mb24' key={`${item.bswReceptionNumber || index}`}>
              <Card.Content>
                <Grid>
                  <Grid.Row>
                    <Grid.Col colS={12} colM={12} colL={12} className='u-mb8'>
                      <span
                        className='u-text-secondary u-text-bold'
                        data-testid='bsw-reception-contents-detail-label'
                        data-testid-e2e='bsw-reception-contents-detail-label'>
                        申込番号/受付番号（受付内容）
                      </span>
                      <p
                        className='report-cards__item-title'
                        data-testid='bsw-reception-contents-detail-value'
                        data-testid-e2e='bsw-reception-contents-detail-value'>
                        {formatFormNumberAndTypeName(item.receptionContentsDetail)}
                      </p>
                    </Grid.Col>
                    <ReceptionContentsTable
                      dataType={'bsw'}
                      acceptedDateTime={item.acceptedDateTime}
                      registrationCrewCode={item.registrationCrewCode}
                      registrationCrewName={item.registrationCrewName}
                      customerCrewCode={item.customerCrewCode}
                      customerCrewName={item.customerCrewName}
                    />
                  </Grid.Row>
                </Grid>
              </Card.Content>
            </Card>
          );
        }
      )}
    </>
  );
};

export default BswReceptionContentsTable;
